import subdomainConfig from "@/config/subdomains";

function detectSubdomain() {
  const hostname = window.location.hostname;

  // localhost 개발환경: ?subdomain=xxx 쿼리스트링으로 테스트
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    const params = new URLSearchParams(window.location.search);
    return params.get("subdomain") || null;
  }

  // 운영환경: 호스트명에서 서브도메인 추출
  // nicelinker.kr, www.nicelinker.kr → null
  // test.nicelinker.kr → 'test'
  const parts = hostname.split(".");
  if (parts.length <= 2) return null;
  const sub = parts[0];
  return sub === "www" || sub === "nicelinker" ? null : sub;
}

const subdomain = detectSubdomain();
const config = subdomain ? (subdomainConfig[subdomain] ?? null) : null;

export default {
  namespaced: true,
  state: () => ({
    subdomain,
    config,
  }),
  getters: {
    subdomain: (state) => state.subdomain,
    isSubdomain: (state) => !!state.config,
    subdomainConfig: (state) => state.config,
    subdomainLabel: (state) => state.config?.label ?? null,
    subdomainMenus: (state) => state.config?.menus ?? {},
    subdomainMainPage: (state) => state.config?.mainPage ?? null,
  },
};
